import React, { Component } from "react";
import {
  configYearToDate,
  yearOptions,
  transformResponseYearsToDateToTable,
} from "../config";
import * as R from "ramda";
import FlexView from "react-flexview";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { mapToObjectDDL, removeNullFields } from "../../../../common/mapper";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { HttpStatus } from "../../../../common/Constants";

class YearToDateReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: null,
      dataSales: [],
      sales: null,
      tableConfig: configYearToDate(),
      dataTable: [],
    };
  }

  componentDidMount = async () => {
    this.setState((prevValue) => ({
      ...prevValue,
      year: yearOptions.find((item) => item.value === new Date().getFullYear()),
    }));
    if (!R.isNil(this.props.kodeCabang?.value)) {
      await this.fetchDataSales();
    }
  };

  componentDidUpdate = async (prevProps) => {
    const prevCabang = prevProps.kodeCabang?.value;
    const currCabang = this.props.kodeCabang?.value;

    if (prevCabang !== currCabang && currCabang) {
      this.setState({
        sales: null,
        dataSales: [],
        dataTable: [],
      });

      await this.fetchDataSales();
    }
  };

  fetchDataSales = async () => {
    this.props.triggerLoading();
    // todo change api to get all sales not just tl
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getSalesDropdownForDashboard,
      setError: this.props.setError,
      menuName:
        "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Sales",
      args: { employeeIdTeamLeader: this.props.idLeader, kodeCabang: this.props.kodeCabang?.value },
    });
    this.props.triggerLoading();
    if (res.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataSales: res.data.data,
      }));
    }
  };

  fetchData = async () => {
    this.props.triggerLoading();
    let req = removeNullFields({
      kodeCabang: [this.props.kodeCabang?.value],
      year: this.state.year?.value,
      employeeIdSales: this.state.sales?.value,
      employeeIdTeamLeader: this.state.idLeader,
    });
    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO")
          .getLaporanPenjualanYTDMetodePembayaranDanLeasing,
      setError: this.props.setError,
      menuName:
        "Dashboard Level Kepala Cabang Keatas - Laporan Jualan Year To Date",
      args: req,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: transformResponseYearsToDateToTable(res.data.data),
      }));
    }
    this.props.triggerLoading();
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.setState(
      (prev) => ({
        ...prev,
        tableConfig: configYearToDate(prev.year?.value),
      }),
      () => this.fetchData(),
    );
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            isClearable
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_sales"
            box="search"
            name="sales"
            isClearable
            containerclassname="width width-250px"
            placeholder="Nama Sales/CS"
            menuPosition="fixed"
            options={this.state.dataSales.map((item) =>
              mapToObjectDDL(item.name, item.employeeId),
            )}
            value={this.state.sales}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableConfig}
        />
      </>
    );
  }
}

export default YearToDateReport;
